import styles from './AssignmentPreview.module.scss';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusChip } from '../StatusChip/StatusChip';
import classNames from 'classnames';
import { BpLink } from '../BpLink/BpLink';
import { useDays } from '../../hooks/useDays';
import { FragmentType, getFragmentData, graphql } from 'client/gql';
import { SubmissionStatus } from 'client/gql/graphql';

const AssignmentPreviewStudentFieldsDocument = graphql(`
  fragment AssignmentPreviewStudentFields on Assignment {
    uuid
    __typename
    title
    dueDate {
      uuid
      __typename
      date
    }
    submissions(where: { owner: { uuid: $profile } }) {
      uuid
      __typename
      status
    }
  }
`);

type AssignmentPreviewStudentProps = {
  onNavigate: (uuid: string) => void;
  query: FragmentType<typeof AssignmentPreviewStudentFieldsDocument> | undefined;
};

export const AssignmentPreviewStudent: FC<AssignmentPreviewStudentProps> = ({ query, onNavigate }) => {
  const assignment = getFragmentData(AssignmentPreviewStudentFieldsDocument, query);
  const { t } = useTranslation();
  const { daysLeft } = useDays();
  const daysDifference = daysLeft(assignment?.dueDate?.date, true);

  if (!assignment) return null;

  return (
    <div className={classNames(styles['assignment-preview'], styles['assignment-preview-student'])}>
      <div className={styles.top}>
        <div className={styles.text}>
          <div className={styles['due-days']}>
            {daysDifference < 0
              ? t('assignments.overdue')
              : t('dates.daysToGo', {
                  count: daysDifference,
                })}
          </div>
          <BpLink value={assignment.title} onNavigate={() => onNavigate(assignment.uuid)} isEditorOfCourse={false} />
        </div>
      </div>
      <StatusChip status={assignment.submissions[0]?.status ?? SubmissionStatus.Todo} isEditorOfCourse={false} />
    </div>
  );
};
